import React from 'react';
import { KEY_COLORS, KEY_COLORS_L2, KEY_COLORS_D2 } from '../../../constants';
import { FilterList } from './styles';
import {
  FaRegCalendarAlt,
  FaRegCalendarCheck,
  FaStar,
  FaInbox,
} from 'react-icons/fa';

export const KeyList = ({
  isMobile = false,
  noMarginRight = true,
  keyList,
  index,
  activeList,
  setActiveList,
  filterTaskCounts,
  setShowTasks = null,
}) => {
  return (
    <FilterList
      isMobile={isMobile}
      noMarginRight={noMarginRight}
      color_l2={KEY_COLORS_L2[index]}
      color_D2={KEY_COLORS_D2[index]}
      color={KEY_COLORS[index]}
      isActive={activeList === keyList}
      onClick={() => {
        setActiveList(keyList);
        if (setShowTasks) setShowTasks(true);
      }}
    >
      <div>
        <div>
          <span className='icon'>
            {index == 0 ? (
              <FaRegCalendarCheck />
            ) : index == 1 ? (
              <FaRegCalendarAlt />
            ) : index == 2 ? (
              <FaStar />
            ) : (
              <FaInbox />
            )}
          </span>
          <h3
            className='title'
            style={{ opacity: activeList === keyList ? 1 : 0.8 }}
          >
            {keyList}
          </h3>
        </div>
        <div className='taskCount' style={{ fontWeight: 'bold', opacity: 0.6 }}>
          {filterTaskCounts[index]}
        </div>
      </div>
      <div>
        <h4
          className='titleSmallScreen'
          style={{ opacity: activeList === keyList ? 1 : 0.8 }}
        >
          {keyList}
        </h4>
      </div>
    </FilterList>
  );
};
